import { GameID, SeasonWeekID, TeamAbrvID } from './id.types';
import { IContextFactors } from './prediction.types';
import { FieldTurfType } from './team.types';

// #region GAME CONTEXT ENRICHMENT **************************************************/
// export type FieldTurfType = 'ArtificialTurf' | 'NaturalGrass';

export enum PlayoffsImplications {
  None = 'None',
  Low = 'Low',
  Medium = 'Medium',
  High = 'High',
}

export enum VenueInfo {
  Home = 'Home',
  Away = 'Away',
  Neutral = 'Neutral',
}

export enum Precipitation {
  None = 'none',
  Rain = 'rain',
  Snow = 'snow',
  Sleet = 'sleet',
  Hail = 'hail',
  FreezingRain = 'freezing_rain',
}

export enum WindDirection {
  N = 'N',
  NE = 'NE',
  E = 'E',
  SE = 'SE',
  S = 'S',
  SW = 'SW',
  W = 'W',
  NW = 'NW',
  None = 'None',
}

export interface IGameWeather {
  temperature: number; // in fahrenheit
  windSpeed: number; // in mph
  windDirection: string; // "N", "NE", "E", "SE", "S", "SW", "W", "NW"
  precipitation: Precipitation;
  visibility: number; // in miles
}

export interface IGameContextEnrichment {
  // Days of Rest
  homeTeamRestDays: number; // 7; // Days since last game
  awayTeamRestDays: number;

  // Venue Information
  venue: {
    type: VenueInfo; // "home" | "away" | "neutral"
    isIndoor: boolean; // Dome or outdoor
    surface: FieldTurfType; // "grass" | "artificial"
  };

  // Game Classification
  isDivisionGame: boolean; // Division rival
  isPlayoffGame: boolean;
  isRivalryGame: boolean; // Historic rivalry
  primeTime: boolean; // Monday/Thursday/Sunday Night

  // Weather (outdoor only)
  weather: IGameWeather;
  // {
  //   temperature: number; // in fahrenheit
  //   windSpeed: number; // in mph
  //   windDirection: string; // "N", "NE", "E", "SE", "S", "SW", "W", "NW"
  //   precipitation: Precipitation;
  //   visibility: number; // in miles
  // };

  // Season Context
  seasonWeekID: SeasonWeekID;
  playoffImplications: PlayoffsImplications; // "high" | "medium" | "low" | "none"
  gameID: GameID;
}

export type TeamBasicContext = {
  id: string;
  name: string;
  logo: string;
  isIndoor: boolean;
  surface: FieldTurfType;
  isHomeTeam: boolean;
  rivalries: TeamAbrvID[];
};

export interface IAdjustedContextFactors {
  adjustedScore: number;
  contextFactors: IContextFactors;
}
